import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    Tooltip
} from "@material-ui/core";
import EnhancedTableHead from "../../PlayersList/EnhancedTableHead";
import {getSort, sortData, countryMap, initColumns} from '../../../util/Util';
import {connect} from "react-redux";
import {
    loadLatestInstance,
    ENTRIES_LOAD,
    SET_PLAYERS_PAGE_SORT,
    SWAP_PLAYERS,
    DELETE_REGISTRATION_ENTRY,
    EDIT_REGISTRATION_ENTRY,
    PLAYERS_PAGE_SEARCH
} from "../../../actions";
import TablePaginationActions from "../../PlayersList/TablePaginationActions";
import {withTranslation} from "react-i18next";
import PlayersPageRow from "./PlayersPageRow";
import EditEntryPanel from "../EditEntry/EditEntryPanel";
import ErrorSnackbar from "../../Snackbars/ErrorSnackbar";
import PlayersToolbar from "./PlayersToolbar";


/*
 * Suggested workflow
 * 1. If no instance selected, fire request to load latest 'Czech Open' - display toast "Loading" and progress bar
 * 2. Once instance is loaded, fire request to load entries for first category in list
 * 3. Once category is loaded, display normally
 */

const styles = (theme) => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 1020,
        width: '100%'
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto'
    }
});


class PlayersPage extends Component {
    state = {
        selectedCategory: '',
        columns: initColumns(1, true),
        data: [],
        errorCode: null,
        errorMessage: null,
        editDialogOpen: false,
        confirmDialogOpen: false,
        confirmDialogAction: null,
        confirmDialogPlayers: null,
        searchFieldValue: '',
        includeDeletedPlayers: true,
    };

    handleCategorySelect = (event) => {
        // should receive categoryId
        const nextCategory = event.target.value;
        if (nextCategory && nextCategory !== this.state.selectedCategory) {
            this.loadCategory(nextCategory, this.state.includeDeletedPlayers);
        }
    };

    handleSearchFieldUpdate = (event) => {
        const includeDeleted = this.state.includeDeletedPlayers;
//        this.setState({searchFieldValue: event.target.value});
        this.loadCategory(this.state.selectedCategory, includeDeleted, event.target.value, true);
//        this.props.searchPlayers(this.state.selectedCategory, event.target.value, includeDeleted);
    }

    handleIncludeDeletedChange = (event) => {
        const {selectedCategory, searchFieldValue} = this.state;
        const includeDeleted = !this.state.includeDeletedPlayers;
        this.loadCategory(selectedCategory, includeDeleted, searchFieldValue, true);
    }

    loadCategory(categoryId, includeDeletedPlayers, searchFieldValue, updateSearchFieldState) {
        let multiplicity = 1;
        this.props.instance.categories.forEach((c) => {
            if (c.id === categoryId) {
                multiplicity = c.multiplicity;
            }
        });
        const columns = initColumns(multiplicity, true);
        const newState = {
            selectedCategory: categoryId,
            data: [],
            order: 'asc',
            orderBy: null,
            columns: columns,
            includeDeletedPlayers: includeDeletedPlayers
        };
        if (updateSearchFieldState) {
            newState['searchFieldValue'] = searchFieldValue;
        }
        this.setState(newState);
        if (searchFieldValue) {
            this.props.searchPlayers(categoryId, searchFieldValue, includeDeletedPlayers);
        } else {
            this.props.loadCategoryEntries(categoryId, includeDeletedPlayers);
        }
    }


    handleChangePage = (event, page) => {
        this.props.setPage(page);
    };

    handleChangeRowsPerPage = event => {
        this.props.setRowsPerPage(event.target.value);
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.props.orderBy === property && this.props.order === 'desc') {
            order = 'asc';
        }

        this.props.setOrder(order, orderBy);
    };

    componentDidMount() {
        if (!this.props.instance) {
            this.props.loadLatestInstance();
        } else if (!this.state.selectedCategory) {
            const inst = this.props.instance;
            if (inst.categories && inst.categories.length > 0) {
                this.loadCategory(inst.categories[0].id, this.state.includeDeletedPlayers, '', false);
            }
        }
    }

    tooltipIcon(icon, tooltipText) {
        return <Tooltip title={tooltipText}>{icon}</Tooltip>;
    }

    handleSwapEntry = (entryId) => {
        this.props.swapPlayers(entryId);
    };

    handleDeleteEntry = (entryId, deleteEntry) => {
        console.log("handleDeleteEntry(" + entryId + ", " + deleteEntry + ")");
        this.setState({
            confirmDialogOpen: true,
            deleteEntryId: entryId,
            deleteEntry: deleteEntry
        });
    };

    handleEditEntry = (entryId) => {
        this.setState({editEntryId: entryId});
        const entry = this.props.entriesMap[entryId];
        this.props.setRegEntryEdit(entry);
    };

    handleSaveEditedEntry = (entry) => {
        // TODO actually save the data - will need to use a saga which
        // sets the status to saving, and then error message if
        // failed, or close dialog + toast on success
        // which means that editEntryId should come from redux, along with the status
        // and error messages
        this.setState({editEntryId: null});
    };

    handleConfirmCancel() {
        this.setState({confirmDialogOpen: false});
    }

    handleConfirmOK() {
        this.setState({confirmDialogOpen: false});
        const {deleteEntryId, deleteEntry} = this.state;
        this.props.deleteRegistrationEntry(deleteEntryId, deleteEntry);
    }

    render() {
        const {classes, t} = this.props;
        const {selectedCategory, includeDeletedPlayers} = this.state;
        const {order, orderBy, currentEntries, page, pageData, rowsPerPage} = this.props;

        const emptyRows = rowsPerPage - pageData.length;

        let categories = [];
        // let columns = initColumns(1);
        if (this.props.instance) {
            categories = this.props.instance.categories;
        }

        let editDialog = null;
        if (this.state.editEntryId) {
            const entry = this.props.entriesMap[this.state.editEntryId];
            editDialog = <EditEntryPanel
                handleSaveEntry={(entry) => this.handleSaveEditedEntry(entry)}
                handleCancel={() => this.handleEditEntry(null)} entry={entry} />;
        }

        let confirmDeleteMessage = '';
        let confirmDialogDesc = '';
        let confirmDailogOKButtonText = '';
        let confirmDialogDescText = '';
        if (this.state.confirmDialogOpen) {
            const {deleteEntry} = this.state;
            if (deleteEntry) {
                confirmDeleteMessage = t("playersEdit.confirmPlayerDelete");
                confirmDailogOKButtonText = t("playersEdit.deleteButton");
                confirmDialogDescText = t("playersEdit.descriptionPlayerDelete");
            } else {
                confirmDeleteMessage = t("playersEdit.confirmPlayerUndelete");
                confirmDailogOKButtonText = t("playersEdit.undeleteButton");
                confirmDialogDescText = t("playersEdit.descriptionPlayerUndelete");
            }
            const entry = this.props.entriesMap[this.state.deleteEntryId];
            confirmDialogDesc = (
                <>
                    {confirmDialogDescText}<br/>
                    {entry.players.map((p, idx) => {
                        return <span key={'ptxt-' + idx}>{p.lastName + ', ' + p.firstName + ' [' + countryMap[p.country].name + ']'}<br/></span>;
                    })}
                </>
            );
        }

        const errorToast = this.props.deleteEntryError ? <ErrorSnackbar message={this.props.deleteEntryError}></ErrorSnackbar> : null;

        return (
            <Paper className={classes.root}>
                <PlayersToolbar
                    title={t("playersEdit.title")}
                    categories={categories}
                    selectedCategory={selectedCategory}
                    handleCategorySelect={(e) => this.handleCategorySelect(e)}
                    searchChangeHandler={(e) => this.handleSearchFieldUpdate(e)}
                    searchFieldValue={this.state.searchFieldValue}
                    includeDeleted={includeDeletedPlayers}
                    includeDeletedChangeHandler={(e) => this.handleIncludeDeletedChange(e)}
                />
                <div className={classes.tableWrapper}>
                    <Table  className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead columns={this.state.columns} order={order} orderBy={orderBy} onRequestSort={(e, p) => this.handleRequestSort(e, p)} />
                        <TableBody>
                            {pageData.map(n => {
                                return <PlayersPageRow
                                    key={n.id}
                                    entryId={n.id}
                                    handleSwapEntry={(e) => this.handleSwapEntry(n.id)}
                                    handleDeleteEntry={(e) => this.handleDeleteEntry(n.id, true)}
                                    handleUndeleteEntry={(e) => this.handleDeleteEntry(n.id, false)}
                                    handleEditEntry={(e) => this.handleEditEntry(n.id)}
                                />
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{height: 49 * emptyRows}}>
                                    <TableCell colSpan={4} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={currentEntries.length}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    labelRowsPerPage={t('playersList.rowsPerPage')}
                    ActionsComponent={TablePaginationActions}
                />
                {editDialog}
                {errorToast}
                <Dialog open={this.state.confirmDialogOpen}>
                    <DialogTitle id="confirm-dialog-title">{confirmDeleteMessage}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="confirm-dialog-description" variant="body2">
                            {confirmDialogDesc}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.handleConfirmCancel()} color="primary">{t("playersEdit.cancelButton")}</Button>
                        <Button onClick={() => this.handleConfirmOK()} color="primary">{confirmDailogOKButtonText}</Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        );
    }
}

const sortPageData = (entries, order, orderBy, page, rowsPerPage) => {
    const sortedData = sortData(entries, getSort(order, orderBy));
    const pageData = sortedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    return pageData;
};

const mapStateToProps = (state) => {
    const order = state.root.playersPageOrder;
    const orderBy = state.root.playersPageOrderBy;
    const page = state.root.playersPagePage;
    const rowsPerPage = state.root.playersPageRowsPerPage;
    const pageData = sortPageData(state.root.currentEntries, order, orderBy, page, rowsPerPage);
    return {
        instance: state.root.currentInstance,
        token: state.root.currentToken,
        loginError: state.root.loadInstanceError,
        currentEntries: state.root.currentEntries,
        pageData: pageData,
        order: order,
        orderBy: orderBy,
        page: page,
        rowsPerPage: rowsPerPage,
        entriesMap: state.root.playersPageEntryMap,
        deleteEntryError: state.root.deleteEntryError
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLatestInstance: () => dispatch(loadLatestInstance('Czech Open')),
        loadCategoryEntries: (categoryId, includeDeleted) => dispatch({type: ENTRIES_LOAD, categoryId: categoryId, includeDeleted: includeDeleted}),
        searchPlayers: (categoryId, searchText, includeDeleted) => dispatch({type: PLAYERS_PAGE_SEARCH, categoryId: categoryId, searchText: searchText, includeDeleted: includeDeleted}),
        setFullSortOptions: (order, orderBy, rowsPerPage, page) => dispatch({
            type: SET_PLAYERS_PAGE_SORT,
            order: order,
            orderBy: orderBy,
            rowsPerPage: rowsPerPage,
            page: page
        }),
        setPage: (page) => dispatch({type: SET_PLAYERS_PAGE_SORT, page: page}),
        setRowsPerPage: (rpp) => dispatch({type: SET_PLAYERS_PAGE_SORT, rowsPerPage: rpp}),
        setOrder: (order, orderBy) => dispatch({type: SET_PLAYERS_PAGE_SORT, orderBy: orderBy, order: order}),
        swapPlayers: (entryId) => dispatch({type: SWAP_PLAYERS, regEntryId: entryId}),
        deleteRegistrationEntry: (entryId, deleteEntry) => dispatch({type:DELETE_REGISTRATION_ENTRY, regEntryId: entryId, deleteEntry: deleteEntry}),
        setRegEntryEdit: (entry) => dispatch({type: EDIT_REGISTRATION_ENTRY, regEntry: entry})
    };
};


export default withTranslation('messages')(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PlayersPage)));
